import {
  ApolloClient,
  InMemoryCache,
  ApolloProvider,
  ApolloLink,
  from,
  HttpLink,
} from '@apollo/client';

import { GRAPHQL_API } from '../config';

import { cookies } from '@/utils';

const authMiddleware = new ApolloLink((operation, forward) => {
  // add the authorization to the headers
  operation.setContext(({ headers = {} }) => ({
    headers: {
      ...headers,
      ...(cookies.getAccess() && { authorization: `Bearer ${cookies.getAccess()}` }),
    },
  }));

  return forward(operation);
});

const httpLink = new HttpLink({
  uri: GRAPHQL_API,
});

const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: from([authMiddleware, httpLink]),
});

const ApolloGraphQL = ({ children }) => {
  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};

export default ApolloGraphQL;
